import apiHandler from "./apiHandler";

const apiPublic = {
  apikey: {
    create: (airline, scope) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .post(`/airline/${airline._id}/apikey/create`, { scope })
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete: (airline, id) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .delete(`/airline/${airline._id}/apikey/delete/${id}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    list: (airline, settings) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .get(`/airline/${airline._id}/apikey/list`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    verify: (key, scope) => {
      return new Promise((resolve, reject) => {
        // defaultPagination(pagination);
        apiHandler
          .get(`/airline/apikey/verify/${key}/${scope}`)
          .then((response) => {
            resolve(response.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  flight: {
    details: (token, id, detail = 4) => {
      return new Promise((resolve, reject) => {
        apiHandler
          .get(`/airline-api/flight/${id}/${detail}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => {
            resolve(response.data.flight);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  airline: {
    flights: {
      onGoing: (token) => {
        return new Promise((resolve, reject) => {
          apiHandler
            .get(`/airline-api/flights/ongoing`, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
              resolve(response.data);
            })
            .catch((err) => {
              reject(err);
            });
        });
      },
    },
  },
};

export default apiPublic;
